var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section__explosive"},[_c('h1',[_vm._v("Our Explosive new lineup.")]),_c('span',{staticClass:"text__span3"},[_vm._v("Best kits for Newcomers.")]),_c('div',{staticClass:"images"},[_c('img',{attrs:{"src":"/assets/Untitled-1.png","alt":"TnT-Kit","id":"tnt-kit"}})])])
}]

export { render, staticRenderFns }